import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from '../../../root-store/root.state';
import { seShowClientInfo, seShowHelp, seShowViewerInfo } from '../../../root-store/root.actions';

@Component({
    selector: 'se-header-about',
    templateUrl: './se-header-about.component.html',
    styleUrls: ['./se-header-about.component.scss'],
})
export class SeHeaderAboutComponent {
    constructor(private store: Store<RootState>) {}

    onHelpClick() {
        this.store.dispatch(seShowHelp());
    }

    onClientInfo() {
        this.store.dispatch(seShowClientInfo());
    }

    onViewerInfo() {
        this.store.dispatch(seShowViewerInfo());
    }
}
